import LegalFooter from "./components/LegalFooter";

export default function TermsConditions({
  sidebarTheme,
  styles,
  showBack,
  onBack,
}) {
  return (
    <div style={s.scrollPage}>
      {showBack && (
        <button
          onClick={onBack}
          style={{
            marginBottom: 24,
            background: "transparent",
            border: "none",
            color: "#7c3aed",
            fontWeight: 700,
            cursor: "pointer",
            fontSize: 14,
          }}
        >
          ← Back
        </button>
      )}

      {/* HEADER */}
      <div style={s.header}>
        <div style={s.title}>Terms & Conditions</div>
        <div style={s.subTitle}>
          SpeedDigits Trainer • Last Updated: January 2026
        </div>
      </div>

      {/* INTRO */}
      <p style={s.intro}>
        By accessing or using SpeedDigits Trainer, you agree to these Terms &
        Conditions. The Application may be used either as a Guest User or as a
        Registered (Logged-in) User. If you do not agree with any part of these
        Terms, discontinue use of the Application.
      </p>

      {/* SECTION 1 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>1. Nature of the Application</h2>
      <p style={s.text}>
        SpeedDigits Trainer is a personal educational software application
        intended for:
      </p>
      <ul style={s.list}>
        <li>Arithmetic and mental calculation practice</li>
        <li>Skill development and speed training</li>
        <li>Performance tracking and self-analysis</li>
      </ul>
      <p style={s.text}>
        The Application is intended solely for learning and practice purposes
        and does not guarantee academic, competitive, or professional outcomes.
      </p>

      {/* SECTION 2 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>2. User Types & Access Modes</h2>

      <p style={s.text}>The Application provides two modes of access:</p>

      <ul style={s.list}>
        <li>
          <strong>Guest Users:</strong> No login is required. Access is limited
          and all data is temporary and session-based. Data may be cleared
          automatically when the session ends or storage is reset.
        </li>
        <li>
          <strong>Registered (Logged-in) Users:</strong> Login is required.
          Additional features such as saved history, performance analysis, and
          profile customization may be available.
        </li>
      </ul>

      <p style={s.text}>
        Feature availability may vary between Guest and Logged-in modes.
      </p>

      {/* SECTION 3 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>3. User Responsibilities</h2>
      <ul style={s.list}>
        <li>Use the Application for lawful and educational purposes only</li>
        <li>Avoid misuse, manipulation, automation, or exploitation</li>
        <li>Provide accurate information where entered voluntarily</li>
        <li>
          Maintain confidentiality of login credentials (for registered users)
        </li>
      </ul>

      {/* SECTION 4 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>4. Data Ownership, Storage & Deletion</h2>
      <ul style={s.list}>
        <li>All generated data belongs entirely to the user</li>
        <li>Guest user data is temporary and may not persist</li>
        <li>
          Logged-in user data may be stored according to system configuration
        </li>
        <li>Data can be deleted at any time using reset controls</li>
      </ul>
      <p style={s.text}>Clearing data is permanent and irreversible.</p>

      {/* SECTION 5 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>5. Guest Mode Limitations</h2>
      <ul style={s.list}>
        <li>Session data may be lost at any time</li>
        <li>Progress and history may not be recoverable</li>
        <li>
          The Application is not responsible for interruptions in Guest sessions
        </li>
      </ul>
      <p style={s.text}>
        Guest mode is provided for convenience and trial purposes only.
      </p>

      {/* SECTION 6 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>6. Accuracy of Results</h2>
      <p style={s.text}>
        Performance metrics and analytics are informational only and may not
        reflect absolute skill levels. Results may vary based on user input,
        configuration, and device performance.
      </p>

      {/* SECTION 7 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>7. Feature Availability & Updates</h2>
      <ul style={s.list}>
        <li>Modify, improve, or remove features</li>
        <li>Change interface or functionality</li>
        <li>Apply updates, fixes, or performance optimizations</li>
      </ul>

      {/* SECTION 8 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>8. No Warranty</h2>
      <p style={s.text}>
        The Application is provided “as is” and “as available” without
        warranties of any kind, including reliability, accuracy, or
        availability.
      </p>

      {/* SECTION 9 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>9. Limitation of Liability</h2>
      <ul style={s.list}>
        <li>No liability for data or progress loss</li>
        <li>No liability for academic or competitive outcomes</li>
        <li>No liability for device, browser, or system issues</li>
        <li>No liability arising from Guest mode usage</li>
      </ul>

      {/* SECTION 10 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>10. Intellectual Property</h2>
      <p style={s.text}>
        All branding, interface design, and application logic are the
        intellectual property of the Application creator. Unauthorized use or
        reproduction is prohibited.
      </p>

      {/* SECTION 11 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>11. Termination of Use</h2>
      <p style={s.text}>
        Users may stop using the Application at any time. Misuse or violation of
        these Terms may result in restricted access.
      </p>

      {/* SECTION 12 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>12. Governing Principles</h2>
      <p style={s.text}>
        These Terms are governed by principles applicable to responsible
        educational software usage.
      </p>

      {/* SECTION 13 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>13. Contact</h2>
      <p style={s.text}>
        For questions or concerns, use the Contact section available within the
        Application.
      </p>

      <LegalFooter styles={s} />
    </div>
  );
}

/* ================= STYLES ================= */

const s = {
  scrollPage: {
    height: "calc(100vh - var(--topbar-height))",
    overflowY: "auto",
    padding: "40px 24px 80px",
  },

  page: {
    maxWidth: 960,
    margin: "0 auto",
    padding: "40px 16px 80px",
  },

  header: {
    textAlign: "center",
    marginBottom: 40,
  },

  title: {
    fontSize: "clamp(32px, 6vw, 52px)",
    fontWeight: 800,
    background: "linear-gradient(90deg,#9333ea,#ec4899)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  subTitle: {
    marginTop: 10,
    fontSize: 14,
    opacity: 0.7,
  },

  intro: {
    textAlign: "center",
    fontSize: 16,
    lineHeight: 1.8,
    opacity: 0.85,
    maxWidth: 720,
    margin: "0 auto 40px",
  },

  divider: {
    width: 220,
    margin: "40px auto",
    borderBottom: "2px dotted rgba(147,51,234,0.5)",
  },

  sectionTitle: {
    textAlign: "center",
    fontSize: 22,
    fontWeight: 700,
    color: "#a855f7",
    marginBottom: 14,
  },

  text: {
    fontSize: 15,
    lineHeight: 1.8,
    marginBottom: 14,
  },

  list: {
    paddingLeft: 22,
    marginBottom: 16,
    lineHeight: 1.9,
  },
};
